import { isMockMode, post, simulateDelay } from "../api";

export const setLicenceState = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Licences/setLicenceState`, data, {
		successMessage: "License state set successfully",
	});
};
